import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { fetchCondiciones, fetchUsos, fetchColores, clearCondiciones, clearUsos, clearColores } from '../../../actions';
import Alert from '../../../components/Alert';

const CondicionCheckbox = props => (
  <div className='checkbox'>
    <label htmlFor={`${props.nroProforma}-${props.codChek}`}>
      <input
        type='checkbox'
        id={`${props.nroProforma}-${props.codChek}`}
        name={`${props.codChek}---${props.desChek}`}
        onChange={e => props.onChangeCondicion(e, props.nroProforma)}
        checked={props.condiciones.indexOf(`${props.codChek}---${props.desChek}`)>=0}
      />
      <div className='checkbox-skin' />
      {props.desChek}
    </label>
  </div>
);

/*Inicio Req 93426 ebarboza 29 11 2021 */
const MostrarWelcomePack = props => {
  return(<table class="table">
        <thead>
          <tr>
            <th style={{width:'20%'}} scope="col">Cod. Equipo</th>
            <th style={{width:'80%'}}  scope="col">Descripción Welcome Pack</th>
          </tr>
        </thead>
        <tbody>
          {props.selectEquipoWelcomePack?props.selectEquipoWelcomePack.map((x,index) =>{
            return(<tr key={x.codEquipo + index}>
            <td key={x.codEquipo} style={{width:'20%'}} >{x.codEquipo}</td>
            <td key={x.descEquipo} style={{width:'80%'}} >{x.descEquipo}</td>
          </tr>)
          }):null}
        </tbody>
      </table>)
};
/*Fin Req 93426 ebarboza 29 11 2021 */

const Color = props => (

  <div className='form-group'>
    <label className='labelInfo' htmlFor={`${props.nroProforma}--${props.position}`}>
      {
        props.position > 0 &&
        <i className='ion-minus-circled c-cyan mr-2' onClick={() => props.removeColor(props.nroProforma, props.position, props.indexProforma)} />
      }
      Color
    </label>
    <div className='select' >
      <select
      className='form-control' id={`${props.nroProforma}--${props.position}`}
      onChange={e => props.onChangeColor(e, props.nroProforma, props.position,props.indexProforma)}
      value={props.value}
      disabled={props.fnDefaultColorProforma(props.nroProforma,props.position) && props.position===0 && props.value!==undefined && props.value!==''? true:false} >
        <option value=''>{props.fnDefaultColorProforma(props.nroProforma,props.position) && props.value!== undefined && props.value!==''?
                        props.colores.filter(({ codPintura }) => codPintura === props.value.split('---')[0])[0].color:'Selecciona un color'}</option>
        {
          props.colores.map(color => (
            <option value={`${color.codPintura}---${color.color}`} key={color.codPintura}>{color.color}</option>
          ))
        }
      </select>
      <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
    </div>
    <span className='formExtraInfo'>
      <i className='ion-information-circled' />
      Color SUNARP: {
        props.value &&
          props.colores.filter(({ codPintura }) => codPintura === props.value.split('---')[0])[0].colorSunarp
      }
    </span>
  </div>
);

const Colores = props => (
  props.cantidad.map((cantidad, index) => (
    <Color
      colores={props.colores}
      key={`${props.nroProforma}-${index}`}
      position={index}
      indexProforma={props.indexProforma}
      value={cantidad}
      removeColor={props.removeColor}
      nroProforma={props.nroProforma}
      onChangeColor={props.onChangeColor}
      reglasNegocio={props.reglasNegocio}
      proformas={props.proformas}
      fnDefaultColorProforma={props.fnDefaultColorProforma}
      fnSetSoloresProformaList={props.fnSetSoloresProformaList}
    />
  ))
);

class SecondStep extends Component {
  constructor(props) {
    super(props);
    let capacitacionesProforma = [];
    let coloresProforma = {};
    let usosProforma = {};
    let condicionesProforma = {};

    this.props.proformas.forEach(({ nroProforma, codFamilia }) => {
      if (codFamilia === '2' || codFamilia === '3') {
        capacitacionesProforma.push(nroProforma);
      }
      usosProforma[nroProforma] = '';
      condicionesProforma[nroProforma] = [];
      coloresProforma[nroProforma] = [''];
    });

    if (this.props.capacitacionesProforma) {
      capacitacionesProforma = this.props.capacitacionesProforma;
    }

    if (this.props.usosProforma) {
      usosProforma = this.props.usosProforma;
    }

    if (this.props.condicionesProforma) {
      condicionesProforma = this.props.condicionesProforma;
    }

    if (this.props.coloresProforma) {
      coloresProforma = this.props.coloresProforma;
    }

    this.state = {
      cardExpanded: this.props.cardExpanded,
      condicionesProforma,
      capacitacionesProforma,
      usosProforma,
      coloresProforma,
    };
  }

  componentDidMount() {

    console.log('this.props.codAreaVta',this.props.codAreaVta);
    if(this.props.codAreaVta!==null){
      this.props.fetchCondiciones(this.props.codAreaVta).then(entry => {
        if(this.props.indCondicionCertificados===0){
                 this.onChangeCondicionDefault();
        }

      });

    }

    this.props.fetchUsos(this.props.proformas);
    this.props.fetchColores(this.props.proformas);

  }




onChangeCondicionDefault=() => {

  let condicion = '';
  const { condicionesProforma } = this.state;

  this.props.proformas.forEach(element => {

    this.props.condiciones.checkCondicion.filter(entry => entry.indDefault==='S').
    forEach(entry => {
        condicion=entry.codChek + '---' + entry.desChek
        if (condicionesProforma[element.nroProforma].indexOf(condicion)>=0) {
          condicionesProforma[element.nroProforma] = condicionesProforma[element.nroProforma]
                                            .filter(cond => cond !== condicion);
        } else {
          condicionesProforma[element.nroProforma] = [...condicionesProforma[element.nroProforma], condicion];
        }
     })
  })


  this.setState({ condicionesProforma });

  this.props.onChangeCondicionCertificados(condicionesProforma);
    this.props.changeIndCondicionCertificados();
}


  onChangeCondicion = (e, proforma) => {
    const condicion = e.target.name;
    const { condicionesProforma } = this.state;
    if (condicionesProforma[proforma].indexOf(condicion)>=0) {
      condicionesProforma[proforma] = condicionesProforma[proforma]
                                        .filter(cond => cond !== condicion);
    } else {
      condicionesProforma[proforma] = [...condicionesProforma[proforma], condicion];
    }
    this.setState({ condicionesProforma });
      this.props.onChangeCondicionCertificados(condicionesProforma);
  }

  onChangeCapacitacion = (e) => {
    const capacitacion = e.target.id;
    const { capacitacionesProforma } = this.state;
    if (capacitacionesProforma.indexOf(capacitacion)>=0) {
      this.setState({ capacitacionesProforma: capacitacionesProforma
                                            .filter(cond => cond !== capacitacion) });
    } else {
      this.setState({ capacitacionesProforma: [...capacitacionesProforma, capacitacion] });
    }
  }

  onChangeColor = (e, proforma, index, indexProforma) => {

    const color = e.target.value;
    const { coloresProformaList } = this.props;
    coloresProformaList[indexProforma][proforma][index]=color;
    this.setState({coloresProforma:coloresProformaList})
    this.props.fnSetSoloresProformaList(coloresProformaList);
  }

  onChangeUso = (e, proforma) => {
    const { usosProforma } = this.state;
    usosProforma[proforma] = e.target.value;
    this.setState({ usosProforma });
  }

  goBack = () => {
    this.props.clearCondiciones();
    this.props.clearUsos();
    this.props.clearColores();
    this.props.previousStep();
  }

  addColor = (proforma,indexProforma) => {
    const { coloresProformaList } = this.props;
    coloresProformaList[indexProforma][proforma].push('');
    this.setState({ coloresProforma:coloresProformaList});
this.props.fnSetSoloresProformaList(coloresProformaList);
  }

  removeColor = (proforma, index, indexProforma) => {
    const { coloresProformaList } = this.props;
    console.log('logger',coloresProformaList);
    console.log('logger',coloresProformaList[indexProforma]);
    coloresProformaList[indexProforma][proforma].splice(index, 1);
    this.setState({ coloresProforma:coloresProformaList });
    this.props.fnSetSoloresProformaList(coloresProformaList);
  }

  toggleCard = (proforma) => {
    const { cardExpanded } = this.state;
    if (cardExpanded.indexOf(proforma)>=0) {
      this.setState({ cardExpanded: cardExpanded.filter(it => it !== proforma) });
    } else {
      this.setState({ cardExpanded: [...cardExpanded, proforma] });
    }
  }
/*Inicio Req 93426 ebarboza 29 11 2021 */
onChangeWelcomePack = (e) => {
  let selectEquipoWelcomePack = this.props.selectEquipoWelcomePack
  console.log(' selectEquipoWelcomePack:: ',selectEquipoWelcomePack);
}
/*Fin Req 93426 ebarboza 29 11 2021 */
  render() {
    const {
      cardExpanded, condicionesProforma, capacitacionesProforma,
      usosProforma,
    } = this.state;
    const { condiciones, usos, colores } = this.props;

    if (!condiciones || !condiciones.checkCondicion || !usos || !colores) return null;

    return (
      <div>
        {
          this.props.nuevaFDV &&
            <p>Una vez creada la Ficha de Venta, podrás editar las condiciones de entrega
            desde la pestaña de <b>Observaciones.</b></p>
        }
        {
          this.props.proformas.map(({nroProforma},index) => {

            const arrowButton = (cardExpanded.indexOf(nroProforma)>=0) ? 'card-lg-title btn-clean' : 'card-lg-title btn-clean collapsed';

            return (
              <div className='card card-plain card-lg form-group' key={nroProforma}>
                <button className={arrowButton} onClick={() => this.toggleCard(nroProforma)}>
                  <h3>Proforma {nroProforma}
                    <i className='ion-chevron-up ml-3 c-cyan' /></h3>
                </button>
                <Panel
                  className='custom-panel card-panel'
                  collapsible
                  expanded={!(cardExpanded.indexOf(nroProforma)>=0)}
                >
                  <div className='form-group'>
                    {
                      condiciones.checkCondicion.map(condicion => (
                        <CondicionCheckbox
                          {...condicion}
                          nroProforma={nroProforma}
                          onChangeCondicion={this.onChangeCondicion}
                          key={condicion.codChek}
                          condiciones={condicionesProforma[nroProforma]}
                        />
                      ))
                    }
                  </div>
                  <div className='row'>
                    <div className='col-md-6'>
                      <Colores
                        colores={colores[nroProforma]}
                        cantidad={this.props.coloresProformaList[index][nroProforma]}
                        removeColor={this.removeColor}
                        nroProforma={nroProforma}
                        onChangeColor={this.onChangeColor}
                        reglasNegocio={this.props.reglasNegocio}
                        proformas={this.props.proformas}
                        fnDefaultColorProforma={this.props.fnDefaultColorProforma}
                        fnSetSoloresProformaList={this.props.fnSetSoloresProformaList}
                        indexProforma={index}
                      />
                      <button className='btn btn-iconLeft btn-link pull-right' onClick={() => this.addColor(nroProforma,index)}                       disabled={this.props.fnDefaultColorProforma(nroProforma,0) && this.props.coloresProformaList[index][nroProforma][0]!==undefined && this.props.coloresProformaList[index][nroProforma][0]!==''? true:false}>
                        <i className='ion-plus' />
                        <span>Agregar color</span>
                      </button>
                      {/*Inicio Req 93426 ebarboza 29 11 2021 */}
                      <button style={{    marginRight: '30px'}} className='btn btn-iconLeft btn-link pull-right' onChangeWelcomePack={e => this.onChangeWelcomePack(e) } onClick={() => this.props.getFetchWelcomePack(nroProforma,index) }  /* disabled={this.props.fnDefaultColorProforma(nroProforma,0) && this.props.coloresProformaList[index][nroProforma][0]!==undefined && this.props.coloresProformaList[index][nroProforma][0]!==''? true:false}*/>
                        <i className='ion-plus' />
                        <span>Agregar Welcome Pack</span>
                      </button>
                      {/*Fin Req 93426 ebarboza 29 11 2021 */}
                    </div>
                    <div className='col-md-6 col-xs-12'>
                      <label className='labelInfo' htmlFor={`uso-${nroProforma}`}>Uso</label>
                      <div className='select'>
                        <select className='form-control' value={usosProforma[nroProforma]} id={`uso-${nroProforma}`} onChange={e => this.onChangeUso(e, nroProforma)}>
                          <option value=''>Selecciona un uso</option>
                          {
                            usos[nroProforma].map(data => (
                              <option value={`${data.codAVtaFamUso}---${data.desUsoVeh}`} key={data.codAVtaFamUso}>
                                {data.desUsoVeh}
                              </option>
                            ))
                          }
                        </select>
                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                      </div>
                    </div>
                  </div>
                </Panel>
                {/*Inicio Req 93426 ebarboza 29 11 2021 */}
                <MostrarWelcomePack 
                selectEquipoWelcomePack= {this.props.selectEquipoWelcomePack}
                />
                {/*Fin Req 93426 ebarboza 29 11 2021 */}
              </div>
            );
          })
        }
        { this.props.nuevaFDV &&
          <div className='form-group'>
            <label className='labelInfo' htmlFor='observaciones'>Obervaciones (opcional)</label>
            <textarea className='form-control' id='observaciones' name='observaciones' onChange={this.props.onChangeValue} value={this.props.observaciones} maxLength='300' />
          </div>
        }
        <div className='modal-actions'>
          <button type='button' className='btn btn-return' onClick={this.goBack}>Anterior</button>
          <button
            type='submit'
            className='btn btn-primary pull-right'
            onClick={() => this.props.nextStep(this.state)}
          >
            Siguiente
          </button>
        </div>

        {
          this.props.condiciones && this.props.condiciones.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar condiciones</p>
            </Alert> : null
        }

        {
          this.props.usos && this.props.usos.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar usos</p>
            </Alert> : null
        }

        {
          this.props.colores && this.props.colores.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar colores</p>
            </Alert> : null
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    condiciones: state.condiciones,
    usos: state.usos,
    colores: state.colores,
  };
}

export default connect(
  mapStateToProps, {
    fetchCondiciones, fetchUsos, fetchColores, clearCondiciones, clearUsos, clearColores,
  })(SecondStep);



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/SecondStep.js